module.exports = __webpack_public_path__ + "static/media/loginbox.af368815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/loginbox.jpg
// module id = 450
// module chunks = 0